import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@chakra-ui/react';
import { Loader } from '@googlemaps/js-api-loader';
import { HotelBrand } from '@whitbread-eos/api';
import { formatAssetsUrl, formatDataTestId, waitForElement, analytics } from '@whitbread-eos/utils';
import getConfig from 'next/config';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import initializeMap from '../../utils/initializeMap';
import DLPMapHotelCard from '../MapHotelCard';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function MapViewDLPVariant(_ref) {
  var items = _ref.items,
    icons = _ref.icons,
    baseDataTestId = _ref.baseDataTestId,
    latitude = _ref.latitude,
    longitude = _ref.longitude,
    hideHotelDistance = _ref.hideHotelDistance;
  var _ref2 = getConfig() || {},
    _ref2$publicRuntimeCo = _ref2.publicRuntimeConfig,
    publicRuntimeConfig = _ref2$publicRuntimeCo === void 0 ? {} : _ref2$publicRuntimeCo;
  var hotelMapRef = useRef(null);
  var hotelOverlayRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    displayedItem = _useState2[0],
    setDisplayedItem = _useState2[1];
  useEffect(() => {
    var loader = new Loader({
      apiKey: publicRuntimeConfig.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
      version: 'weekly',
      libraries: []
    });
    loader.load().then(() => {
      if (hotelMapRef !== null && hotelMapRef !== void 0 && hotelMapRef.current) {
        var hotelMap = initializeMap(latitude, longitude, hotelMapRef, publicRuntimeConfig.NEXT_PUBLIC_GOOGLE_MAP_ID_DLP);
        displayMarkers(hotelMap, items, icons, latitude, longitude, hotelOverlayRef, setDisplayedItem);
      }
    });
  }, [items, baseDataTestId, latitude, longitude, icons, publicRuntimeConfig.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY]);
  return _jsxs(_Fragment, {
    children: [hotelOverlayRef.current && displayedItem && ReactDOM.createPortal(_jsx(DLPMapHotelCard, {
      data: displayedItem,
      hideHotelDistance: hideHotelDistance
    }), hotelOverlayRef.current), _jsx(Box, _objectSpread({
      "data-testid": formatDataTestId(baseDataTestId, 'mapView'),
      ref: hotelMapRef
    }, mapContainerStyles))]
  });
}
export function createMarkers(_x, _x2, _x3, _x4, _x5) {
  return _createMarkers.apply(this, arguments);
}
function _createMarkers() {
  _createMarkers = _asyncToGenerator(function* (items, hotelMap, icons, hotelOverlayRef, setDisplayedItem) {
    var _ref5 = yield google.maps.importLibrary('marker'),
      AdvancedMarkerElement = _ref5.AdvancedMarkerElement;
    var markers = items.map(item => {
      var _item$coordinates$lat, _item$coordinates, _item$coordinates$lon, _item$coordinates2, _item$distanceFromRef;
      var pin = document.createElement('img');
      var selected = document.createElement('img');
      var iconKey;
      switch (item.brand) {
        case HotelBrand.ZIP:
          iconKey = 'icon.pin-zip';
          break;
        case HotelBrand.HUB:
          iconKey = 'icon.pin-hub';
          break;
        default:
          iconKey = 'icon.pin-default';
          break;
      }
      var src = formatAssetsUrl(icons[iconKey]);
      pin.src = src;
      pin.dataset.originalSrc = src;
      selected.src = formatAssetsUrl(icons['icon.pin-selected']);
      selected.dataset.originalSrc = src;
      var marker = new AdvancedMarkerElement({
        position: {
          lat: (_item$coordinates$lat = (_item$coordinates = item.coordinates) === null || _item$coordinates === void 0 ? void 0 : _item$coordinates.latitude) !== null && _item$coordinates$lat !== void 0 ? _item$coordinates$lat : 0,
          lng: (_item$coordinates$lon = (_item$coordinates2 = item.coordinates) === null || _item$coordinates2 === void 0 ? void 0 : _item$coordinates2.longitude) !== null && _item$coordinates$lon !== void 0 ? _item$coordinates$lon : 0
        },
        map: hotelMap,
        content: pin
      });
      marker.selectedContent = selected;
      marker.defaultContent = pin;
      marker.hotelBrandLabel = item.brand;
      marker.hotelDistanceFromSearch = ((_item$distanceFromRef = item.distanceFromReference) !== null && _item$distanceFromRef !== void 0 ? _item$distanceFromRef : 0).toFixed(2);
      attachHotelCard({
        marker,
        hotelMap,
        hotelOverlayRef,
        setDisplayedItem,
        item,
        icons
      });
      return marker;
    });
    markers.forEach(marker => marker.addListener('click', () => {
      markers.forEach(marker => marker.content = marker.defaultContent);
      marker.content = marker.selectedContent;
      analytics.update({
        dlp: _objectSpread(_objectSpread({}, window.analyticsData.dlp), {}, {
          hotelBrandLabel: marker.hotelBrandLabel,
          hotelDistanceFromSearch: marker.hotelDistanceFromSearch
        })
      });
    }));
    return markers;
  });
  return _createMarkers.apply(this, arguments);
}
export function createRegionMarker(_x6, _x7, _x8, _x9) {
  return _createRegionMarker.apply(this, arguments);
}
function _createRegionMarker() {
  _createRegionMarker = _asyncToGenerator(function* (latitude, longitude, hotelMap, icons) {
    var _ref6 = yield google.maps.importLibrary('marker'),
      AdvancedMarkerElement = _ref6.AdvancedMarkerElement;
    var pin = document.createElement('img');
    pin.src = formatAssetsUrl(icons['icon.pin-city']);
    return new AdvancedMarkerElement({
      position: {
        lat: latitude !== null && latitude !== void 0 ? latitude : 0,
        lng: longitude !== null && longitude !== void 0 ? longitude : 0
      },
      map: hotelMap,
      content: pin
    });
  });
  return _createRegionMarker.apply(this, arguments);
}
function getMapBounds(markers) {
  var bounds = new google.maps.LatLngBounds();
  markers.forEach(marker => {
    var markerPosition = marker.position;
    bounds.extend(markerPosition);
  });
  return bounds;
}
function displayMarkers(_x0, _x1, _x10, _x11, _x12, _x13, _x14) {
  return _displayMarkers.apply(this, arguments);
}
function _displayMarkers() {
  _displayMarkers = _asyncToGenerator(function* (hotelMap, hotels, icons, latitude, longitude, hotelOverlayRef, setDisplayedItem) {
    var markers = [...(yield createMarkers(hotels, hotelMap, icons, hotelOverlayRef, setDisplayedItem)), yield createRegionMarker(latitude, longitude, hotelMap, icons)];
    var bounds = getMapBounds(markers);
    hotelMap.fitBounds(bounds);
  });
  return _displayMarkers.apply(this, arguments);
}
var infoWindow;
export function attachHotelCard(_ref3) {
  var marker = _ref3.marker,
    hotelMap = _ref3.hotelMap,
    hotelOverlayRef = _ref3.hotelOverlayRef,
    setDisplayedItem = _ref3.setDisplayedItem,
    item = _ref3.item,
    icons = _ref3.icons;
  var stringyfiedContent = "<div id=\"hotel-overlay\"></div>";
  infoWindow = new google.maps.InfoWindow({
    content: stringyfiedContent
  });
  marker.addListener('click', _asyncToGenerator(function* () {
    infoWindow.open({
      map: hotelMap,
      anchor: marker
    });
    yield waitForElement('#hotel-overlay');
    var activePin = marker.querySelector('img');
    if (activePin) {
      activePin.src = formatAssetsUrl(icons['icon.pin-selected']);
    }
    var el = document.getElementById('hotel-overlay');
    var revertAndClose = () => {
      infoWindow.close();
      if (activePin !== null && activePin !== void 0 && activePin.dataset.originalSrc) {
        activePin.src = activePin.dataset.originalSrc;
      }
    };
    if (el) {
      hotelOverlayRef.current = el;
      setDisplayedItem(item);
      infoWindow.addListener('closeclick', revertAndClose);
      google.maps.event.addListener(hotelMap, 'click', revertAndClose);
      google.maps.event.addListener(hotelMap, 'drag', revertAndClose);
    }
  }));
}
var mapContainerStyles = {
  height: '100%'
};